import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { Search } from '@mui/icons-material';
import { TextField, Autocomplete, IconButton } from '@totalsoft/rocket-ui';
import { DateTime } from '@ts-private/rocket-extensions';
import Close from '@mui/icons-material/Close';

const BulkPrintingListFilters = ({ filters, documentStates, onChangeFilterValue, onFilterReset }) => {
  const { t } = useTranslation();

  return (
    <Grid item container xs={12} spacing={2}>
      <Grid item xs={12} sm={6} lg={3}>
        <TextField
          id={'bulkPrinting_fullTextFilter'}
          fullWidth
          label={t('Search')}
          name='fullTextFilter'
          value={filters.fullTextFilter}
          onChange={onChangeFilterValue('fullTextFilter')}
          startAdornment={<Search />}
          endAdornment={
            <IconButton
              id={'offerList_filters_resetBtn'}
              tooltip={t('Tooltips.ResetFilters')}
              color='primary'
              variant='text'
              size='tiny'
              onClick={onFilterReset}
            >
              <Close />
            </IconButton>
          }
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={3}>
        <TextField
          id={'bulkPrinting_filters_offerNumber'}
          fullWidth
          label={t('BulkPrinting.OfferNumber')}
          name='offerNumber'
          value={filters.offerNumber}
          onChange={onChangeFilterValue('offerNumber')}
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={3}>
        <DateTime
          id={'bulkPrinting_filters_offerStartDate'}
          label={t('BulkPrinting.OfferStartDate')}
          value={filters.offerStartDate}
          onChange={onChangeFilterValue('offerStartDate')}
          isClearable
          timeFormat={false}
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={3}>
        <DateTime
          id={'bulkPrinting_filters_offerEndDate'}
          label={t('BulkPrinting.OfferEndDate')}
          value={filters.offerEndDate}
          onChange={onChangeFilterValue('offerEndDate')}
          isClearable
          timeFormat={false}
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={3}>
        <Autocomplete
          id={'bulkPrinting_filters_offerStateId'}
          fullWidth
          valueKey='stateId'
          value={filters.offerStateId}
          onChange={onChangeFilterValue('offerStateId')}
          labelKey='name'
          label={t('BulkPrinting.OfferStateName')}
          options={documentStates}
          isSearchable
          isClearable
          simpleValue
        />
      </Grid>
    </Grid>
  );
};

BulkPrintingListFilters.propTypes = {
  documentStates: PropTypes.array.isRequired,
  filters: PropTypes.object.isRequired,
  onChangeFilterValue: PropTypes.func.isRequired,
  onFilterReset: PropTypes.func.isRequired
};

export default BulkPrintingListFilters;
